// extracted by mini-css-extract-plugin
export default {"editor":"Editor_editor__Gjdp8","noEvents":"Editor_noEvents__8z0bG","spinner":"Editor_spinner__FvzcX","hidden":"Editor_hidden__P0sBv"};